export const ACCOUNT_PROFILE_DISPLAY_NAME_FALLBACK = "Unknown User";

export const CHROME_EXTENSION_ONBOARDING_URL = "https://get.mem.ai/chrome-extension";
